export default "__VITE_ASSET__CbRHZzs1__"